import { render, staticRenderFns } from "./DonationThankYou.vue?vue&type=template&id=cabcae80"
import script from "./DonationThankYou.vue?vue&type=script&lang=js"
export * from "./DonationThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports